import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { format, isValid, startOfMonth, set } from 'date-fns';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import SearchIcon from '@material-ui/icons/Search';
import PDFIcon from '@material-ui/icons/ViewHeadline';
import Visibility from '@material-ui/icons/Visibility';
import Reactivate from '@material-ui/icons/Work';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import axios from '../../config/axiosInstance';

// import Typography from '@material-ui/core/Typography';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';

import SelectTable from '../../components/DataTable/SelectTable';
import { fetchDissmissEmployee } from '../../store/actions/employee';
import {
  requestTimeClockReport,
  requestImportAfd1510Report,
  requestImportAfd671Report,
  requestPhotoReport,
  requestLocationReport,
  requestAbsenceReport
} from '../../store/actions/report';
import ContentHeader from '../../components/ContentHeader/ContentHeader';
import Input from '../../components/Input/Input';
import { setLoading, setMessage } from '../../store/actions/general';

const styles = theme => ({
  container: {
    padding: `0 ${theme.spacing(3)}px`,
  },
});

class Dismissed extends React.Component {
  state = {
    withExtraHours: false,
    startDate: '',
    endDate: '',
    selected: [],
    searchQuery: '',
    reports: null,
    openModal: false,
    openModalReports: false,
    currentItem: null,
    reportType: '',
    reportName: '',
  };

  componentWillMount() {
    this.setState({
      startDate: startOfMonth(new Date()),
      endDate: set(new Date(), { hours: 23, minutes: 59, seconds: 59 }),
    });
  }

  componentDidMount() {
    this.props.onFetchDissmissEmployees();
  }

  observerNewHandleRequestReport = (value) => {
    if (this.state.uuid == 'impresso') {
      this.setState({ loading: false })
    } else {
      this.setState({ loading: true })
      setTimeout(() => this.handleRequestpdf(value), 5000)
    }
  };

  newHandleRequestReport = () => {
    this.setState({ openModalReports: false });
    setLoading(true)
    const warning = localStorage.setItem('warningPre', true);
    this.setState({ loadingMirror: true })
    this.setState({ loading: true })

    const {
      startDate, endDate, selected, autoFix, nightExtraHoursInThePDF, isToConsiderNightHoursCorrected
    } = this.state;

    const report = {
      start: format(startDate, 'yyyy/MM/dd HH:mm'),
      end: format(endDate, 'yyyy/MM/dd HH:mm'),
      employees: selected
    };
    const jwt = require('jsonwebtoken');
    const decodedToken = jwt.decode(localStorage.token);
    this.setState({ numSelected: selected.length })
    const companyData = JSON.parse(localStorage.getItem('companies')).find(name => name.companyName);
    // usageLog("relatórios/espelho_de_ponto/novo_espelho", companyData.companyId, companyData.userId)
    this.setState({ companyName: companyData.companyName })

    const requestOptions = {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        'Accept': '/',
      },
      body: JSON.stringify({
        startPeriod: report.start,
        endPeriod: report.end,
        employeesId: selected,
        companyId: decodedToken.companyId,
        autoFix: false,
        nightExtraHoursInThePDF: false,
        isToConsiderNightHoursCorrected: false
      })
    };
    fetch('https://puntuapi.eastus.cloudapp.azure.com/api/timesheet/timesheet-request', requestOptions)
      .then((response) => response.json())
      .then((data) => {
        this.handleRequestpdf();
        this.setState({ loadingMirror: true })
        this.setState({ uuid: data.uuid })
        this.observerNewHandleRequestReport(data.uuid);
        this.handleRequestpdf();
      })
  };

  handleRequestpdf = (uuid) => {
    const jwt = require('jsonwebtoken');
    const decodedToken = jwt.decode(localStorage.token);
    let nameReport
    if (this.state.numSelected > 1) {
      nameReport = `Relatório Espelho de Ponto - ${this.state.companyName}.pdf`
    } else {
      nameReport = `Relatório Espelho de Ponto - ${this.state.name}.pdf`
    }

    fetch(`https://puntuapi.eastus.cloudapp.azure.com/api/timesheet/${decodedToken.companyId}/${uuid}`)
      .then((response) => {
        const contentType = response.headers.get('Content-Type');
        if (contentType == 'application/json; charset=utf-8') {
          response.json()
            .then((data) => {
              if (data.stateMessage != 'Infelizmente deu um erro, verifique os dados dos funcionários e tente novamente!') {
                this.setState({ loadingMirrorMessage: data.stateMessage })
                this.observerNewHandleRequestReport(this.state.uuid);
              } else if (data.stateMessage == 'Infelizmente deu um erro, verifique os dados dos funcionários e tente novamente!') {
                this.setState({ loadingMirrorMessage: data.stateMessage })
                setTimeout(() => {
                  this.setState({ loadingMirror: false, loading: false });
                }, 4000);
              }
            })
        } else {
          response.blob()
            .then(blob => {
              if (blob.size > 100) {
                this.setState({ loading: false })
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = nameReport;
                document.body.appendChild(a);
                a.click();
                a.remove();
                this.setState({ buttonLoadingMirrorMessage: true })
                this.setState({ loadingMirrorMessage: 'Oba, Confira seu espelho de ponto nos downloads!' })
                setLoading(false)
              }
            });
        }

      })
  };

  confirmReport = () => {
    this.setState({ openModalReports: true });

    const {
      startDate, endDate, selected, withExtraHours,
    } = this.state;

    const selecao = selected.map(s => this.props.employees.filter(e => e.id === s)[0]);

    const report = {
      start: format(startDate, 'yyyy/MM/dd HH:mm'),
      end: format(endDate, 'yyyy/MM/dd HH:mm'),
      employees: selecao.map(s => s.id),
      showCosts: true,
    };

    if (this.state.reportType === 'EP') {
      this.newHandleRequestReport(report);
    }
    if (this.state.reportType === 'AFD') {
      this.props.onRequestAfdReport(report);
    }
    if (this.state.reportType === 'AFDT') {
      this.props.onRequestAfdtReport(report);
    }
    if (this.state.reportType === 'PF') {
      this.props.onRequestPhotoReport(report);
    }
    if (this.state.reportType === 'PL') {
      this.props.onRequestLocationReport(report);
    }
    if (this.state.reportType === 'FP') {
      this.props.onRequestAbsenceReport(report);
    }
  };

  handleRequestReport = (report) => {
    this.setState({ openModalReports: true, reportType: report });
    if (report === 'EP') {
      this.setState({ reportName: 'Espelho de ponto' });
    }
    if (report === 'PF') {
      return this.setState({ reportName: 'Pontos com fotos' });
    }
    if (report === 'PL') {
      return this.setState({ reportName: 'Pontos fora do local' });
    }
    if (report === 'FP') {
      return this.setState({ reportName: 'Faltas por periodo' });
    }
    if (report === 'AFD') {
      return this.setState({ reportName: 'AFD' });
    }
    if (report === 'AFDT') {
      return this.setState({ reportName: 'AFDT' });
    }
  };

  handleInputChange = name => (event) => {
    if (event.target) {
      const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
      this.setState({ [name]: value });
    } else {
      this.setState({ [name]: event });
    }
  };

  handleSelectAll = (event, checked, searchSelect) => {
    const searchIndex = searchSelect.map(employee => employee.id);

    if (checked) {
      const newSelected = this.state.selected.slice();

      /* eslint-disable no-underscore-dangle */
      if (searchIndex) {
        if (this.state.selected.indexOf(searchIndex[0]) === -1) {
          this.props.employees.map(employee =>
          (searchIndex.indexOf(employee.id) > -1 &&
            newSelected.indexOf(employee.id) === -1 &&
            employee._workingDay !== null
            ? newSelected.push(employee.id)
            : null));
        } else {
          this.props.employees.map(employee =>
          (searchIndex.indexOf(employee.id) > -1 && employee._workingDay !== null
            ? newSelected.splice(newSelected.indexOf(employee.id), 1)
            : null));
        }
      }
      /* eslint-enable */

      this.setState({ selected: newSelected });
    } else if (searchIndex.length === this.props.employees.length) {
      this.setState({ selected: [] });
    } else {
      const newSelected = this.state.selected.slice();
      this.props.employees.map(employee =>
      (searchIndex.indexOf(employee.id) > -1 && employee._workingDay !== null
        ? newSelected.splice(newSelected.indexOf(employee.id), 1)
        : null));

      this.setState({ selected: newSelected });
    }
  };

  handleSelect = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  handleClickMenu = (event) => {
    this.setState({ reports: event.currentTarget });
  }

  handleCloseMenu = () => {
    this.setState({ reports: null });
  }

  handleVisualizationClick = (item) => {
    const employee = this.props.employees.filter(i => i.id === item.id);
    this.setState({ openModal: true, currentItem: employee });
    console.log(this.setState({ openModal: true, currentItem: employee }))
  }

  handleReactivateClick = (item) => {
    const cpf = this.props.employees.filter(i => i.id === item.id).map(i => i.cpf);
    axios.delete('employee/reactivateEmployees',
      { data: { cpfs: cpf } }
    )
      .then(() => {
        this.componentDidMount(this.props.onFetchDissmissEmployees);
      })
  }

  handleActionCancel = () => {
    this.setState({ openModal: false });
  };

  handleOpenReports = () => {
    this.setState({ openModalReports: true });
  }

  handleActionCancelReports = () => {
    this.setState({ openModalReports: false });
  };

  render() {
    const {
      classes, employees, loading,
    } = this.props;
    const {
      startDate, endDate, selected, searchQuery, reports,
    } = this.state;

    const columns = [
      { name: 'name', label: 'Nome' },
      { name: 'dtdemission', label: 'Data de demissão' },
      { name: 'dtlastdaywork', label: 'Último dia trabalhado' },

    ];

    const searchFields = ['name'];

    const actions = [
      {
        name: 'Visualizar',
        icon: Visibility,
        handleClick: item => this.handleVisualizationClick(item),
      },
      {
        name: 'Reativar',
        icon: Reactivate,
        handleClick: item => this.handleReactivateClick(item),
      },
    ];

    return (
      <React.Fragment>
        <ContentHeader
          title="Desligados"
          subtitle="Selecione os funcionários que foram desligados para gerar relatórios"
        >
          <Button
            variant="contained"
            color="primary"
            // onClick={this.handleRequestReport}
            onClick={this.handleClickMenu}
            disabled={loading || !(selected.length)}
          >
            <PDFIcon /> Gerar Relatório
          </Button>

          <Menu
            anchorEl={reports}
            open={Boolean(reports)}
            onClose={this.handleCloseMenu}
          >
            <MenuItem onClick={() => this.handleRequestReport('EP')}>Espelho de ponto </MenuItem>
            <MenuItem onClick={() => this.handleRequestReport('AFD')}>AFD</MenuItem>
            <MenuItem onClick={() => this.handleRequestReport('AFDT')}>AFDT</MenuItem>
            <MenuItem onClick={() => this.handleRequestReport('PF')}>Pontos com Fotos </MenuItem>
            <MenuItem onClick={() => this.handleRequestReport('PL')}>Pontos com Localização</MenuItem>
            <MenuItem onClick={() => this.handleRequestReport('FP')}>Faltas por Perído</MenuItem>
          </Menu>

        </ContentHeader>


        <Paper elevation={2}>
          <Grid
            container
            justify="space-between"
            alignItems="baseline"
            className={classes.container}
          >
            <Grid item xs={12} md={5}>
              {/* <FormControlLabel
                control={
                  <Checkbox
                    checked={withExtraHours}
                    onChange={this.handleInputChange('withExtraHours')}
                    value="withExtraHours"
                    color="primary"
                  />
                }
                label="Incluir cálculo de Horas Extras"
              /> */}
              <TextField
                value={searchQuery}
                onChange={this.handleInputChange('searchQuery')}
                label=" "
                placeholder="Buscar"
                type="text"
                fullWidth
                margin="normal"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="disabled" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            {/* <Grid item xs={12} md={6} container justify="space-around">
              <Input
                elementType="dateTimePicker"
                label="Início do período"
                margin="normal"
                value={startDate}
                onChange={this.handleInputChange('startDate')}
              />
              <Input
                elementType="dateTimePicker"
                label="Fim do período"
                margin="normal"
                value={endDate}
                onChange={this.handleInputChange('endDate')}
              />
            </Grid> */}
          </Grid>

          <SelectTable
            rows={employees}
            columns={columns}
            actions={actions}
            loading={loading}
            disableRow="_workingDay"
            searchFields={searchFields}
            onSelect={this.handleSelect}
            onSelectAll={this.handleSelectAll}
            onSearchSelect={this.handleSearchSelect}
            checkSelect={this.isSelected}
            numSelected={selected.length}
            searchQuery={searchQuery.toUpperCase()}
          />
        </Paper>

        <Dialog open={this.state.openModal} onClose={this.handleActionCancel} >
          <DialogTitle> Visualização </DialogTitle>
          <DialogContent>
            <form style={{ display: 'flex', flexWrap: 'wrap' }} >

              {
                this.state.currentItem ?
                  <TextField
                    type="text"
                    label="Nome"
                    value={this.state.currentItem[0].name ? this.state.currentItem[0].name : 'Sem cadastro'}
                    style={{ marginLeft: 20, marginRight: 20, width: 200 }}
                  /> : ''
              }
              {
                this.state.currentItem ?
                  <TextField
                    type="text"
                    label="Telefone"
                    value={this.state.currentItem[0].phone ? this.state.currentItem[0].phone : 'Sem cadastro'}
                    style={{ marginLeft: 20, marginRight: 20, width: 200 }}
                  /> : ''
              }
              {
                this.state.currentItem ?
                  <TextField
                    type="text"
                    label="PIS"
                    value={this.state.currentItem[0].pisCode ? this.state.currentItem[0].pisCode : 'Sem cadastro'}
                    style={{
                      marginLeft: 20, marginRight: 20, width: 200, marginTop: 19,
                    }}
                  /> : ''
              }
              {
                this.state.currentItem ?
                  <TextField
                    type="text"
                    label="CPF"
                    value={this.state.currentItem[0].cpf ? this.state.currentItem[0].cpf : 'Sem cadastro'}
                    style={{
                      marginLeft: 20, marginRight: 20, width: 200, marginTop: 19,
                    }}
                  /> : ''
              }

              {
                this.state.currentItem ?
                  <TextField
                    type="text"
                    label="Matricula"
                    value={this.state.currentItem[0].byUser ? this.state.currentItem[0].byUser : 'Sem cadastro'}
                    style={{
                      marginLeft: 20, marginRight: 20, width: 200, marginTop: 19,
                    }}
                  /> : ''
              }
              {
                this.state.currentItem ?
                  <TextField
                    type="text"
                    label="Email"
                    value={this.state.currentItem[0].emailContact ? this.state.currentItem[0].emailContact : 'Sem cadastro'}
                    style={{
                      marginLeft: 20, marginRight: 20, width: 200, marginTop: 19,
                    }}
                  /> : ''
              }
              {
                this.state.currentItem ?
                  <TextField
                    type="text"
                    label="CEP"
                    value={this.state.currentItem[0].postalCode ? this.state.currentItem[0].postalCode : 'Sem cadastro'}
                    style={{
                      marginLeft: 20, marginRight: 20, width: 200, marginTop: 19,
                    }}
                  /> : ''
              }
              {
                this.state.currentItem ?
                  <TextField
                    type="text"
                    label="Endereço"
                    value={this.state.currentItem[0].adress ? this.state.currentItem[0].adress : 'Sem cadastro'}
                    style={{
                      marginLeft: 20, marginRight: 20, width: 200, marginTop: 19,
                    }}
                  /> : ''
              }

            </form>
            <DialogContentText>
              {/* Informações do Empregado desligado */}
            </DialogContentText>
            {/* pulo do gato */}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleActionCancel}>Fechar</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.openModalReports} onClose={this.handleActionCancelReports} >
          <DialogTitle> Relatório {this.state.reportName ? this.state.reportName : this.state.reportType}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Informações da Data do Relatorio
            </DialogContentText>
            <Grid item xs={12} container justify="space-around">
              <Input
                elementType="dateTimePicker"
                label="Início do período"
                margin="normal"
                value={startDate}
                onChange={this.handleInputChange('startDate')}
              />
              <div style={{ marginRight: 20 }} />
              <Input
                elementType="dateTimePicker"
                label="Fim do período"
                minDate={startDate}
                margin="normal"
                value={endDate}
                onChange={this.handleInputChange('endDate')}
              />
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.confirmReport} variant="contained" color="primary" autoFocus>
              CONFIRMAR
            </Button>
            <Button
              onClick={this.handleActionCancelReports}
              disabled={loading || !(isValid(startDate) && isValid(endDate) && selected.length)}
            >CANCELAR
            </Button>
          </DialogActions>
        </Dialog>

        {/* <Typography color="textSecondary" style={{ marginTop: '10px' }}>
          *Não é possível gerar relatório de funcionários sem escala cadastrada
        </Typography> */}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.general.loading,
  employees: state.employee.dissmissList,
  teste: state.employee.dissmissList,
});

const mapDispatchToProps = dispatch => ({
  onFetchDissmissEmployees: () => dispatch(fetchDissmissEmployee()),
  // onRequestReport: report => dispatch(newRequestTimeClockReport(report)),
  onRequestAfd1510Report: report => dispatch(requestImportAfd1510Report(report)),
  onRequestAfd671Report: report => dispatch(requestImportAfd671Report(report)),
  onRequestPhotoReport: report => dispatch(requestPhotoReport(report)),
  onRequestLocationReport: report => dispatch(requestLocationReport(report)),
  onRequestAbsenceReport: report => dispatch(requestAbsenceReport(report)),
});

Dismissed.propTypes = {
  classes: PropTypes.object.isRequired,
  onFetchDissmissEmployees: PropTypes.func.isRequired,
  onRequestReport: PropTypes.func.isRequired,
  employees: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};

Dismissed.defaultProps = {
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(Dismissed));
